import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

export default function ThankYou() {
  const location = useLocation();
  const navigate = useNavigate();

  const donor = location.state?.donor;

  if (!donor) {
    navigate("/", { replace: true });
    return null;
  }

  return (
    <div>
      {/* Navbar logo/title only, buttons hidden */}
      <Navbar hideNavButtons={true} />

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          backgroundColor: "#f0f0f0",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            backgroundColor: "#0077cc",
            color: "white",
            padding: "40px 30px",
            borderRadius: "15px",
            minWidth: "320px",
            maxWidth: "500px",
            width: "100%",
            boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
            textAlign: "left",
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
            Thank you for your meaningful contribution!
          </h2>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div><strong>Name:</strong> {donor.name}</div>
            <div><strong>Email:</strong> {donor.email}</div>
            <div><strong>Contact:</strong> {donor.contact}</div>
            <div><strong>Amount:</strong> ₹{donor.amount}</div>
          </div>

          <p style={{ marginTop: "30px", fontSize: "0.9rem", opacity: 0.8, textAlign: "center" }}>
            Your support makes a difference! 🌱
          </p>
        </div>
      </section>
    </div>
  );
}
